import { useMemo } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';
import { Label } from '@/components/ui/label';
import { CalendarDays, Calendar as CalendarIcon } from 'lucide-react';
import { format, parseISO } from 'date-fns';

export function UnavailabilityDialog({ open, onOpenChange, tocData }) {
  const sortedDates = useMemo(() => {
    if (!tocData?.declined_dates?.length) return [];
    return [...tocData.declined_dates].sort();
  }, [tocData?.declined_dates]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CalendarDays className="h-5 w-5 text-slate-600" />
            {tocData?.toc_name}'s Unavailability
          </DialogTitle>
          <DialogDescription>
            Dates when this Sub is unavailable to work
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          {tocData?.declined_all_today && (
            <div className="p-3 bg-amber-50 rounded-lg border border-amber-200">
              <p className="text-sm font-medium text-amber-800">
                Unavailable Today ({tocData.declined_all_today})
              </p>
            </div>
          )}
          
          {sortedDates.length > 0 ? (
            <div className="space-y-2">
              <Label className="text-sm font-medium">Blocked Dates:</Label>
              <div className="max-h-48 overflow-y-auto space-y-1 border rounded-lg p-3 bg-slate-50">
                {sortedDates.map((dateStr) => {
                    const date = parseISO(dateStr);
                    const isPast = date < new Date();
                    return (
                      <div 
                        key={dateStr} 
                        className={`flex items-center justify-between p-2 rounded ${
                          isPast ? 'bg-slate-100 text-slate-400' : 'bg-white'
                        }`}
                      >
                        <span className="text-sm">
                          {format(date, 'EEEE, MMMM d, yyyy')}
                        </span>
                        {isPast && (
                          <Badge variant="outline" className="text-xs">Past</Badge>
                        )}
                      </div>
                    );
                  })}
              </div>
              <p className="text-xs text-slate-500">
                {sortedDates.length} date{sortedDates.length !== 1 ? 's' : ''} blocked
              </p>
            </div>
          ) : (
            <div className="text-center py-6 text-slate-500">
              <CalendarIcon className="h-10 w-10 mx-auto mb-2 opacity-50" />
              <p>This Sub has no blocked dates.</p>
              <p className="text-xs mt-1">They're available for all upcoming positions!</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
